import { useEffect, useState } from 'react';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { useSnackbar } from 'notistack';
import { useProductsPrices } from 'pages/products/api';
import { appendPricingToProducts } from 'pages/products/utils';
import { Product } from '@setvi/shared/interfaces';
import { SimilarProductsProps } from '../..';

export const useSimilarProducts = ({
  product,
  selectedCustomer
}: Pick<SimilarProductsProps, 'product' | 'selectedCustomer'>) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const { enqueueSnackbar } = useSnackbar();
  const { token } = useAppContext();

  const { getPrices } = useProductsPrices();

  const fetchProducts = async () => {
    try {
      const params = new URLSearchParams({
        sku: product.sku,
        topK: '10'
      });
      const response: Product[] = await fetch(
        `${process.env.INTELLIGENCE_API_BASE_URL}/api/1.0/products/similar?${params.toString()}`,
        {
          method: 'GET',
          headers: new Headers({
            Authorization: `Bearer ${token}`
          })
        }
      )
        .then(res => res.json())
        .then(res => res.products);

      const simProducts = response.map(i => ({
        ...i,
        // @ts-ignore
        price: null,
        // ! Remove this when the API response is fixed because it returns id for prduct id instead of _id to match Algolia Product interface
        // @ts-ignore
        _id: i?._id || i.id
      }));

      if (selectedCustomer && simProducts?.length) {
        const prices = await getPrices({
          productList: simProducts,
          accountNumber: selectedCustomer?.accountNumber
        });

        const appendedArr = appendPricingToProducts(simProducts, prices);

        setProducts(appendedArr);
      } else setProducts(simProducts);
    } catch (e) {
      enqueueSnackbar('Error occured while fetching product data.', {
        variant: 'error',
        autoHideDuration: 8000
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    products,
    isLoading
  };
};
